import React from 'react';

export const GoogleCalendarSVG = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <rect width="20" height="20" rx="4" fill="white" />
        <path
            d="M13.5088 6.49121H6.49121V13.5088H13.5088V6.49121Z"
            fill="white"
        />
        <path
            d="M13.5088 16.6667L16.6667 13.5088H13.5088V16.6667Z"
            fill="#EA4335"
        />
        <path
            d="M16.6667 6.49121H13.5088V13.5088H16.6667V6.49121Z"
            fill="#FBBC04"
        />
        <path
            d="M13.5088 13.5088H6.49121V16.6667H13.5088V13.5088Z"
            fill="#34A853"
        />
        <path
            d="M3.3335 13.5088V15.6141C3.3335 16.1956 3.80455 16.6667 4.38613 16.6667H6.49139V13.5088H3.3335Z"
            fill="#188038"
        />
        <path
            d="M16.6667 6.49127V4.38601C16.6667 3.80443 16.1956 3.33337 15.6141 3.33337H13.5088V6.49127H16.6667Z"
            fill="#1967D2"
        />
        <path
            d="M13.5089 3.33337H4.38613C3.80455 3.33337 3.3335 3.80443 3.3335 4.38601V13.5088H6.49139V6.49127H13.5089V3.33337Z"
            fill="#4285F4"
        />
        <path
            d="M7.93068 11.9351C7.6684 11.7579 7.48682 11.4991 7.3877 11.157L7.99647 10.9061C8.05173 11.1167 8.14822 11.2798 8.28594 11.3956C8.42278 11.5114 8.58945 11.5684 8.78419 11.5684C8.98331 11.5684 9.15436 11.5079 9.29734 11.3868C9.44033 11.2658 9.51226 11.1114 9.51226 10.9245C9.51226 10.7333 9.43682 10.5772 9.28594 10.4561C9.13506 10.3351 8.94559 10.2745 8.71927 10.2745H8.36752V9.67191H8.68331C8.87805 9.67191 9.04208 9.61928 9.17541 9.51402C9.30875 9.40876 9.37541 9.2649 9.37541 9.08156C9.37541 8.91841 9.31577 8.78858 9.19647 8.69121C9.07717 8.59384 8.92629 8.54472 8.74296 8.54472C8.56401 8.54472 8.42191 8.59209 8.31664 8.6877C8.21145 8.78357 8.13236 8.90462 8.08682 9.03946L7.48419 8.78858C7.56401 8.56227 7.7105 8.36227 7.92541 8.18946C8.14033 8.01665 8.41489 7.92981 8.74822 7.92981C8.99471 7.92981 9.21664 7.97718 9.41313 8.07279C9.60962 8.16841 9.76401 8.30086 9.87541 8.46928C9.98682 8.63858 10.0421 8.82806 10.0421 9.03858C10.0421 9.25349 9.99033 9.43507 9.88682 9.5842C9.78331 9.73332 9.65612 9.84735 9.50524 9.92718V9.96314C9.70006 10.0435 9.86929 10.1754 9.99471 10.3447C10.1219 10.5158 10.1859 10.7202 10.1859 10.9588C10.1859 11.1974 10.1254 11.4105 10.0044 11.5974C9.88331 11.7842 9.71577 11.9316 9.50348 12.0386C9.29033 12.1456 9.05085 12.2 8.78506 12.2C8.47717 12.2009 8.19296 12.1123 7.93068 11.9351ZM11.6702 8.91402L11.0017 9.39735L10.6675 8.89034L11.8666 8.02542H12.3263V12.1052H11.6702V8.91402Z"
            fill="#4285F4"
        />
    </svg>
);

GoogleCalendarSVG.displayName = 'GoogleCalendarSVG';
